/**
 * SuperAdmin Settings — /superadmin/settings (route shell).
 *
 * Screen impl in `./settings-screen.tsx`, lazy-loaded. Platform-operator-only
 * surface (behind the /superadmin layout gate).
 */

import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';

export const Route = createFileRoute('/superadmin/settings')({
  component: lazyRouteComponent(() => import('./settings-screen'), 'SettingsPlaceholder'),
});
